import { render, staticRenderFns } from "./SupplierManufacturingHygiene.vue?vue&type=template&id=12da3d9a&scoped=true"
import script from "./SupplierManufacturingHygiene.vue?vue&type=script&lang=js"
export * from "./SupplierManufacturingHygiene.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12da3d9a",
  null
  
)

export default component.exports